import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";

import type { MethodItemPayloadType } from "@/common/types/method/method-item";

export async function methodItemList(
  account_id: string,
  group_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/method/${group_id}/item/list${queryString}`,
  );
}

export async function methodItemShow(account_id: string, method_id: string) {
  return await clientAxios.get(
    `account/${account_id}/method/item/${method_id}/show`,
  );
}

export async function methodItemCreate(
  account_id: string,
  method_id: string,
  payload: MethodItemPayloadType,
) {
  const formated = {
    ...payload,
    metadata:
      typeof payload.metadata === "object"
        ? JSON.stringify(payload.metadata)
        : payload.metadata,
  };

  return await clientAxios.post(
    `account/${account_id}/method/${method_id}/item/create`,
    formated,
  );
}

export async function methodItemUpdate(
  account_id: string,
  method_id: string,
  payload: MethodItemPayloadType,
) {
  const formated = {
    ...payload,
    metadata:
      typeof payload.metadata === "object"
        ? JSON.stringify(payload.metadata)
        : payload.metadata,
  };

  return await clientAxios.put(
    `account/${account_id}/method/item/${method_id}/update`,
    formated,
  );
}

export async function methodItemDelete(account_id: string, method_id: string) {
  return await clientAxios.del(
    `account/${account_id}/method/item/${method_id}/delete`,
  );
}

export async function methodItemUpload(
  account_id: string,
  group_id: string,
  payload: FileType,
) {
  return await clientAxios.post(
    `account/${account_id}/method/${group_id}/item/upload`,
    payload,
  );
}

export async function methodItemModelCSV(account_id: string, group_id: string) {
  return await clientAxios.get(
    `account/${account_id}/method/${group_id}/item/csv/model`,
  );
}
